import { useCallback, useEffect, useState } from "react";
import { TenantService } from "@propertelligent/client-api";
import apiHelper from "../../utils/apiHelper";

export const useTenantData = (tenantId: number) => {
  const [tenantData, setTenantData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  // True only when the fetch itself failed (network/server error) -- distinct from a successful
  // fetch that legitimately returns no unit. Callers must not treat a failed fetch as "moved out".
  const [fetchFailed, setFetchFailed] = useState(false);

  const fetchTenantData = useCallback(async () => {
    if (!tenantId) return;
    try {
      setLoading(true);
      const res: any = await apiHelper(
        TenantService.getApiTenant1,
        { showNotification: false },
        tenantId
      );
      // apiHelper never throws -- it catches internally and always resolves, returning
      // `data: null` on any failure (network/server error/4xx/5xx). That's the only reliable
      // signal a request failed; a try/catch around this call would never fire for it.
      if (res?.data == null) {
        setFetchFailed(true);
      } else {
        setTenantData(res.data.success ?? null);
        setFetchFailed(false);
      }
    } catch (err) {
      console.error("Error fetching tenant data:", err);
      setFetchFailed(true);
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => {
    fetchTenantData();
  }, [fetchTenantData]);

  return { tenantData, loading, fetchFailed, refetchTenantData: fetchTenantData };
};
